// selection manager: minimal dependency, pure JS helper
// 用于管理跨页的选中集合（支持分页合并、回填、清理）
export function createSelectionManager(initial = []) {
  // 内部使用 Set 保证唯一性，所有 id 转为 Number
  let set = new Set((initial || []).map(id => Number(id)));

  return {
    // 返回所有已选 id 的数组副本
    getAllSelected() {
      return Array.from(set);
    },

    // 直接替换整个已选集合（会把元素转为 Number）
    setSelected(arr) {
      set = new Set((arr || []).map(id => Number(id)));
      return this.getAllSelected();
    },

    // 清空
    clear() {
      set.clear();
    },

    // 是否包含
    isSelected(id) {
      return set.has(Number(id));
    },

    // 合并当前页的选择变更到 master 集合
    // pageIds: 当前页所有条目的 id 列表
    // checkedOnPage: 当前页被勾选的 id 列表
    // 返回最新的全量 selected 数组
    replaceForPage(pageIds = [], checkedOnPage = []) {
      const checkedSet = new Set((checkedOnPage || []).map(id => Number(id)));

      // 把当前页选中的加入 master
      (checkedOnPage || []).forEach(id => set.add(Number(id)));

      // 对于当前页上已取消选择的，从 master 中移除
      (pageIds || []).forEach(id => {
        const n = Number(id);
        if (!checkedSet.has(n) && set.has(n)) {
          set.delete(n);
        }
      });

      return this.getAllSelected();
    }
  };
}
